import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { DomainService } from '../services/domain.service';

@Injectable()
export class DomainGuard implements CanActivate {

    constructor(
        private router: Router,
        private service: DomainService
    ) {
    }

    canActivate(): boolean {
        if (this.service.isValidDomain()) {
            // domain is valid so return true
            return true;
        }

        // not valid so send it to missing
        this.router.navigateByUrl('/missing', { skipLocationChange: true });

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/domain.guard.ts